import React, { useState, useEffect, useCallback } from 'react';
import { Mail, MailOpen, Trash2, Eye } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../lib/api';

export default function MessagesManager() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  const fetchMessages = useCallback(() => {
    api.get('/messages').then(r => setMessages(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  useEffect(() => { fetchMessages(); }, [fetchMessages]);

  const handleRead = async (id) => {
    try {
      await api.put(`/messages/${id}/read`);
      fetchMessages();
    } catch (err) {
      toast.error('Hata');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Silmek istediğinize emin misiniz?')) return;
    try {
      await api.delete(`/messages/${id}`);
      toast.success('Mesaj silindi');
      setSelected(null);
      fetchMessages();
    } catch (err) {
      toast.error('Silme hatası');
    }
  };

  return (
    <div data-testid="admin-messages-manager">
      <h1 className="font-heading text-2xl font-semibold mb-6">İletişim Mesajları</h1>

      {/* Detail Modal */}
      {selected && (
        <div className="mb-6 p-6 rounded-2xl bg-card border border-border shadow-[var(--shadow-elev-1)]">
          <div className="flex items-start justify-between mb-4">
            <div>
              <h3 className="font-heading text-lg font-semibold">{selected.name}</h3>
              <p className="text-sm text-muted-foreground">{selected.email} {selected.phone && `| ${selected.phone}`}</p>
              <p className="text-xs text-muted-foreground mt-1">{new Date(selected.created_at).toLocaleString('tr-TR')}</p>
            </div>
            <button onClick={() => setSelected(null)} className="text-muted-foreground hover:text-foreground">&times;</button>
          </div>
          <div className="p-4 rounded-xl bg-secondary text-sm whitespace-pre-line">{selected.message}</div>
          <div className="mt-4 flex gap-3">
            {!selected.is_read && (
              <button onClick={() => { handleRead(selected.id); setSelected({ ...selected, is_read: true }); }}
                className="px-4 py-2 rounded-lg bg-[hsl(var(--gold))] text-[hsl(var(--accent-foreground))] text-sm font-medium">
                Okundu İşaretle
              </button>
            )}
            <button onClick={() => handleDelete(selected.id)}
              className="px-4 py-2 rounded-lg bg-destructive text-destructive-foreground text-sm font-medium">
              Sil
            </button>
          </div>
        </div>
      )}

      {loading ? (
        <div className="flex justify-center py-10"><div className="w-8 h-8 border-2 border-[hsl(var(--gold))] border-t-transparent rounded-full animate-spin" /></div>
      ) : messages.length === 0 ? (
        <div className="text-center py-10 text-muted-foreground">Henüz mesaj yok</div>
      ) : (
        <div className="space-y-2">
          {messages.map(msg => (
            <div
              key={msg.id}
              className={`flex items-center gap-4 p-4 rounded-xl border cursor-pointer transition-colors ${
                msg.is_read ? 'bg-card border-border' : 'bg-[hsl(var(--gold)/0.05)] border-[hsl(var(--gold)/0.2)]'
              } hover:bg-secondary`}
              onClick={() => { setSelected(msg); if (!msg.is_read) handleRead(msg.id); }}
            >
              <div className="w-8 h-8 rounded-full flex items-center justify-center shrink-0">
                {msg.is_read ? <MailOpen className="w-4 h-4 text-muted-foreground" /> : <Mail className="w-4 h-4 text-[hsl(var(--gold))]" />}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className={`text-sm ${msg.is_read ? '' : 'font-semibold'}`}>{msg.name}</span>
                  <span className="text-xs text-muted-foreground">{msg.email}</span>
                </div>
                <p className="text-xs text-muted-foreground truncate">{msg.message}</p>
              </div>
              <span className="text-xs text-muted-foreground shrink-0">
                {new Date(msg.created_at).toLocaleDateString('tr-TR')}
              </span>
              <div className="flex gap-1 shrink-0">
                <button onClick={(e) => { e.stopPropagation(); setSelected(msg); }} className="p-1.5 rounded-lg hover:bg-secondary"><Eye className="w-4 h-4" /></button>
                <button onClick={(e) => { e.stopPropagation(); handleDelete(msg.id); }} className="p-1.5 rounded-lg hover:bg-destructive/10 text-destructive"><Trash2 className="w-4 h-4" /></button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
